import isFunction from 'lodash/isFunction'
import { AnySourceStream, Stream, Subscription } from '../stream'
import { Pass } from './pass'

export class DeliverAll<V = any, E = any, C = any> extends Pass<V, E, C> {
    public values: V[] = []

    subscribe(value?: (value: V) => void, error?: (error: E) => void, complete?: (complete: C) => void): () => void
    subscribe(subscription: Subscription<V, E, C>): () => void
    subscribe(
        valueOrSubscription?: Subscription<V, E, C> | ((value: V) => void),
        error?: (error: E) => void,
        complete?: (complete: C) => void
    ) {
        const isSubscription = !(error || complete || isFunction(valueOrSubscription))

        const sub = isSubscription
            ? (valueOrSubscription as Subscription<V, E, C>)
            : { value: valueOrSubscription as (value: V) => void, error, complete }

        if (sub.value && !this.subscriptions.has(sub)) {
            for (const value of this.values) {
                sub.value(value)
            }
        }

        return super.subscribe(sub)
    }

    value(value: V) {
        super.value(value)
        this.values.push(value)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        deliverAll(): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.deliverAll = function <V, E, C>(this: AnySourceStream<V, E, C>) {
    return new DeliverAll(this) // tslint:disable-line:no-invalid-this
}
